import { render, staticRenderFns } from "./PrHeader.vue?vue&type=template&id=3d4aea5d&scoped=true&"
import script from "./PrHeader.vue?vue&type=script&lang=js&"
export * from "./PrHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrHeader.vue?vue&type=style&index=0&id=3d4aea5d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4aea5d",
  null
  
)

export default component.exports